<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'CourseCategoryGetVo' : 'CourseCategoryAddVo'"
            :data="tmpCourseCategory" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateCourseCategory"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateCourseCategoryLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{courseCategory.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== courseCategory.name"
          @click="onDeleteCourseCategory"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteCourseCategoryLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'CourseCategory',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpCourseCategory: {},
      updateCourseCategoryLoading: false,
      deleteCourseCategoryLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      courseCategory: state => state.course.courseCategory,
    }),
  },
  methods: {
    ...mapActions({
      getCourseCategory: 'course/getCourseCategory',
      updateCourseCategory: 'course/updateCourseCategory',
      addCourseCategory: 'course/addCourseCategory',
      deleteCourseCategory: 'course/deleteCourseCategory',
    }),
    ...mapMutations({
      setCourseCategory: 'course/setCourseCategory',
    }),
    goBack() {
      this.$router.push({path: '/course-category'})
    },
    onFormChange (data) {
      this.tmpCourseCategory = {...data}
    },
    onAddOrUpdateCourseCategory () {
      if (this.tmpCourseCategory.id) {
        this.updateCourseCategoryLoading = true
        this.updateCourseCategory(this.tmpCourseCategory)
          .then(() => {
            this.updateCourseCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseCategoryLoading = false
          })
      } else {
        this.updateCourseCategoryLoading = true
        this.addCourseCategory(this.tmpCourseCategory)
          .then(() => {
            this.updateCourseCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseCategoryLoading = false
          })
      }
    },
    onDeleteCourseCategory () {
      this.deleteCourseCategoryLoading = true
      this.deleteCourseCategory(this.courseCategory.id)
          .then(() => {
            this.deleteCourseCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteCourseCategoryLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getCourseCategory(this.$route.params.id).then(() => {
        this.tmpCourseCategory = this.courseCategory
      })
    }
  },
  destroyed() {
    this.setCourseCategory({})
  }
}
</script>
